module.exports = __webpack_public_path__ + "img/cd30fdc.jpg";